import React, { useEffect, useContext } from "react";
import "./mark-for-later-list.scss";
import ProgressBar from "../progressBar/progressBar";
import { SurveyContext } from "../../store/survey-context";
import MFL_Active_SVG from "../../assets/images/MarkForLater_Active.svg";
import BodyClassName from "react-body-classname";
import { useTranslation } from "react-i18next";
import { setAppBackground } from "../../utils";

export default function MarkForLaterList(props) {
  const context = useContext(SurveyContext);
  const { t } = useTranslation(["common", "survey"]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setAppBackground(`Hero-1b.png`);

    window.dataLayer?.push({
      event: "mtcExpScreen",
      screen: "Navigation - Mark for later",
      step: 5,
    });

    if (window.hj) {
      window.hj("stateChange", "questionnaire/nav/markforlater");
    }
  }, []);

  const {
    survey,
    markedForLater,
    chapterOneProgress,
    chapterTwoProgress,
    chapterThreeProgress,
    chapterFourProgress,
  } = context;

  // sort the pages by chapter and position
  const sorted = [];
  if (survey) {
    markedForLater.forEach((crmId) => {
      const page = survey.pages.find((item) => item.crmId === crmId);
      if (!page || !page.isVisible) return;
      const pageIndex = survey.pages.findIndex((item) => item.crmId === crmId);

      if (!sorted[page.chapter]) {
        sorted[page.chapter] = [];
      }
      sorted[page.chapter][pageIndex] = page;
    });
  }
  function goToPage(page) {
    context.survey.isOnMarkedForLaterList = true;
    if (context.survey.currentPage.name === page.name) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      const prevBtn = document.querySelector(".survey-buttons .btn--link");
      if (prevBtn) {
        prevBtn.style.display = "none";
      }
    }
    context.survey.currentPage = page;
    if (context.showSplash) {
      context.setSplash(false);
    }
    context.toggleSurvey(true);
  }

  function showList(sorted, chapter) {
    return sorted[chapter].map((page) => {
      //console.log(page);
      if (page) {
        return (
          <li
            key={page.crmId}
            className="navigation-list-item navigation-list-item--marked active"
          >
            <button onClick={() => goToPage(page)} className="nav-link">
              <div className="nav-link__title">{page.elements[0]?.title}</div>
              <div className="active-arrow"></div>
            </button>
          </li>
        );
      }
      return null;
    });
  }

  return (
    <>
      <BodyClassName className="mark-for-latter" />
      <button
        className="navigation-back"
        onClick={() => {
          survey.isOnMarkedForLaterList = false;
          props.close();
        }}
      >
        {t("button.back_to_menu")}
      </button>
      <div className="icon">
        <img src={MFL_Active_SVG} alt={t("nav.marked_for_later")} />
      </div>
      <h1 className="headline--tertiary headline--marked">
        {t("nav.marked_for_later")}:
      </h1>
      <nav
        className="navigation navigation--mfl"
        aria-label={t("nav.mfl_navigation")}
      >
        <ul className="navigation-list">
          {sorted[1] && (
            <>
              <li className="navigation-list-item active readonly">
                <div className="nav-link">
                  <div className="nav-link__title">
                    <i className="icon icon-chapter-one"> </i>
                    <div className="nav-link__wrap">
                      <span className="chapterName tag">
                        {t("survey.chapters.ch_1.label", { ns: "survey" })}{" "}
                      </span>
                      <h3 className="chapterTitle headline--quaternary">
                        {t("survey.chapters.ch_1.name", { ns: "survey" })}
                      </h3>
                    </div>
                  </div>
                  <div className="active-arrow"></div>
                  <ProgressBar progress={chapterOneProgress} />
                </div>
              </li>
              {showList(sorted, 1)}
            </>
          )}

          {sorted[2] && (
            <>
              <li className="navigation-list-item active readonly">
                <div className="nav-link">
                  <div className="nav-link__title">
                    <i className="icon icon-chapter-two"> </i>
                    <div className="nav-link__wrap">
                      <span className="chapterName tag">
                        {t("survey.chapters.ch_2.label", { ns: "survey" })}{" "}
                      </span>
                      <h3 className="chapterTitle headline--quaternary">
                        {t("survey.chapters.ch_2.name", { ns: "survey" })}
                      </h3>
                    </div>
                  </div>
                  <div className="active-arrow"></div>
                  <ProgressBar progress={chapterTwoProgress} />
                </div>
              </li>
              {showList(sorted, 2)}
            </>
          )}

          {sorted[3] && (
            <>
              <li className="navigation-list-item active readonly">
                <div className="nav-link">
                  <div className="nav-link__title">
                    <i className="icon icon-chapter-three"> </i>
                    <div className="nav-link__wrap">
                      <span className="chapterName tag">
                        {t("survey.chapters.ch_3.label", { ns: "survey" })}{" "}
                      </span>
                      <h3 className="chapterTitle headline--quaternary">
                        {t("survey.chapters.ch_3.name", { ns: "survey" })}
                      </h3>
                    </div>
                  </div>
                  <div className="active-arrow"></div>
                  <ProgressBar progress={chapterThreeProgress} />
                </div>
              </li>
              {showList(sorted, 3)}
            </>
          )}

          {sorted[4] && (
            <>
              <li className="navigation-list-item active readonly">
                <div className="nav-link">
                  <div className="nav-link__title">
                    <i className="icon icon-chapter-four"> </i>
                    <div className="nav-link__wrap">
                      <span className="chapterName tag">
                        {t("survey.chapters.ch_4.label", { ns: "survey" })}{" "}
                      </span>
                      <h3 className="chapterTitle headline--quaternary">
                        {t("survey.chapters.ch_4.name", { ns: "survey" })}
                      </h3>
                    </div>
                  </div>
                  <div className="active-arrow"></div>
                  <ProgressBar progress={chapterFourProgress} />
                </div>
              </li>
              {showList(sorted, 4)}
            </>
          )}
        </ul>
      </nav>
    </>
  );
}
